<template>
    <div>
        <b-modal
            id="nationalPatentResponsibleFormModal" centered size="xl" no-close-on-backdrop ref="nationalPatentResponsibleFormModal" :title=" $t('nationalPatentResponsible.info')" :cancel-title=" $t('others.cancel_title')"
            :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" hide-footer>
            <b-card no-body class="border mt-1">
                <b-card-header class="p-1">
                  <b-card-title class="font-medium-2">
                    <feather-icon icon="LockIcon" size="18" />
                    <span class="align-middle ml-50">{{  $t('nationalPatentResponsible.responsible')  }}</span>
                  </b-card-title>
                </b-card-header>
                <!--eslint-disable-->
                <table class="table table-striped table-bordered">
                  <tbody>
                    <tr v-for="nationalPatentResponsibleItem in nationalPatentResponsibleList" :key="nationalPatentResponsibleItem.id">
                      <td >
                          <b-form-checkbox @change="changeResponsible($event, nationalPatentResponsibleItem.id, nationalPatentResponsibleItem.mailContactTypeId)" />                                 
                      </td>
                      <td>{{ nationalPatentResponsibleItem.name  }}</td>
                        <td>{{ nationalPatentResponsibleItem.email  }}</td>
                        <td>
                            <b-form-select v-model="nationalPatentResponsibleItem.mailContactTypeId" value-field="id" text-field="name" :options="mailContactTypeList" />
                        </td>
                        <td>{{ nationalPatentResponsibleItem.responsibleField  }}</td>
                    </tr>
                  </tbody>
                </table>
            </b-card>
        </b-modal>
    </div>
</template>
<script>
export default{
  props: {
      getNationalPatentResponsibleList: {type: Function},
    },
  data(){
    return {
      id: 0,
      nationalPatentResponsibleList:[],
      mailContactTypeList:[],
    }
  }, 
  methods:{
    changeResponsible(selected, clientResponsibleId, mailContactTypeId) {
      const controller = { name: 'NationalPatentResponsible' }
      if (selected == true) {
        const data = { nationalPatentId: this.nationalPatentId, clientResponsibleId: clientResponsibleId, mailContactTypeId: mailContactTypeId }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/save', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.getNationalPatentResponsibleList()
            this.$SaveAlert()
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
        })
      }
    },
    showInfo(nationalPatentId, clientId) {
      this.$refs['nationalPatentResponsibleFormModal'].show()
          this.nationalPatentId= nationalPatentId
          const data = {clientId: clientId, nationalPatentId: nationalPatentId}
          const controller = {name: 'ClientResponsible', actionName:'GetClientResponsibleListForModules'}
          const payload = {data: data, controller: controller}
          this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
              if(response.data.resultStatus == true){    
                  this.nationalPatentResponsibleList = response.data.clientResponsibleList
                  this.mailContactTypeList = response.data.mailContactTypeList
              } else {
                  this.$bvModal.hide('nationalPatentResponsibleFormModal')
                  this.$WarningAlert(response.data.resultMessage)
              }  
          }) 
      },
  }
}
</script>